import { createTheme, ThemeOptions } from '@mui/material/styles';
import { ClientBusinessLine } from '../sic-lib/enums/ClientBusinessLine';
import { themeComponents } from './components';
import { defaultPalette } from './defaultTheme';
import { proctorPalette } from './proctorTheme';

// followed explanation found at
// https://javascript.plainenglish.io/extend-material-ui-theme-in-typescript-a462e207131f

declare module '@mui/material/styles/createPalette' {
    interface PaletteOptions {
        appHeader?: SimplePaletteColorOptions;
        sidebarHeader?: PaletteColorOptions;
        addButton?: PaletteColorOptions;
        menuListHover?: PaletteColorOptions;
        btnDefault?: PaletteColorOptions;
        pageNavigationBar?: PaletteColorOptions;
        conversationTimelinePaper?: PaletteColorOptions;
        backgroundMainLayout?: SimplePaletteColorOptions;
        noteStatus?: PaletteColorOptions;
        tabPills?: PaletteColorOptions;
    }

    interface Palette {
        appHeader: PaletteColor;
        sidebarHeader: PaletteColor;
        addButton: PaletteColor;
        menuListHover: PaletteColor;
        btnDefault: PaletteColor;
        pageNavigationBar: PaletteColor;
        conversationTimelinePaper: PaletteColor;
        backgroundMainLayout: PaletteColor;
        noteStatus: PaletteColor;
        tabPills: PaletteColor;
    }
}

export function getTheme(businessLine: ClientBusinessLine) {
    let palette: ThemeOptions['palette'];

    switch (businessLine) {
        case ClientBusinessLine.proctor:
            palette = proctorPalette;
            break;
        case ClientBusinessLine.other:
        case ClientBusinessLine.default:
        default:
            palette = defaultPalette;
    }

    const themeOptions: ThemeOptions = {
        palette: palette,
        components: themeComponents(palette),
        breakpoints: {
            //this must match _muiVariables.css otherwise js sizing wont match css sizing
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
            },
        },
        shape: {
            borderRadius: 8,
        },
    };

    return createTheme(themeOptions);
}
